var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
/* istanbul ignore file */
// dont see the benefit in tests, will come from components which use it
import axios from "axios";
import { sharedAxiosConfiguration } from "../constants";
// SSO
export var ssoApi = axios.create(__assign(__assign({}, sharedAxiosConfiguration), { baseURL: "".concat(((_a = window === null || window === void 0 ? void 0 : window.config) === null || _a === void 0 ? void 0 : _a.REACT_APP_SSO_API) || process.env.REACT_APP_SSO_API, "v1/") }));
